import React from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";


const CabinetProfilePersonalInformation = () => {
    const { t } = useTranslation();

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                <div className={Styles.titleRow}>
                    <div className={Styles.title}>
                        {t("Привязанные аккаунты и способы оплаты")}
                    </div>
                </div>
                <div className={Styles.csWrap}>
                    {t('Скоро будет доступно')}
                </div>
            </div>
        </div>
    );
};

export default CabinetProfilePersonalInformation;